export default function Announcements() {
  return (
    <div className="cb-announcements">
      <section className="cb-section-intro" aria-labelledby="cb-announcements-title">
        <span className="cb-section-kicker">INFORMATIONS DE CONCOURSBf</span>
        <h1 id="cb-announcements-title">Annonces</h1>
        <p>Cet espace est réservé aux communications propres à l'application.</p>
      </section>

      <section className="cb-announcements-empty" aria-labelledby="cb-announcements-empty-title">
        <span className="cb-announcements-symbol" aria-hidden="true">✦</span>
        <p className="cb-eyebrow">TOUT EST À JOUR</p>
        <h2 id="cb-announcements-empty-title">Aucune annonce pour le moment</h2>
        <p>
          Les annonces de maintenance, les nouveautés et les informations importantes
          de ConcoursBF seront publiées ici lorsqu'elles seront disponibles.
        </p>
        <div className="cb-announcements-notice">
          <strong>À savoir</strong>
          <span>Cette rubrique concerne la plateforme ConcoursBF. Elle ne remplace pas
            les communications officielles des administrations organisatrices des concours.</span>
        </div>
      </section>
    </div>
  );
}
